import { LocaleId } from '@portfolio/configs'
import { groq } from 'next-sanity'
import { coalesceLocaleField } from '../helpers/coalesceLocaleField'
import { createLinkProjection } from './createLinkProjection'
import { createMediaProjection } from './createMediaProjection'

export const createNestedNavigationProjection = (localeId: LocaleId) => {
  const LINK_PROJECTION = createLinkProjection(localeId)
  const MEDIA_PROJECTION = createMediaProjection(localeId)

  return groq`{
    ${coalesceLocaleField('ctaLabel', localeId)},
    ctaLink${LINK_PROJECTION},
    linkGroups[] {
      _key,
      ${coalesceLocaleField('groupLabel', localeId)},
      links[] {
        _key,
        ${coalesceLocaleField('title', localeId)},
        link${LINK_PROJECTION}
      }
    },
    ctaSection {
      ${coalesceLocaleField('title', localeId)},
      ${coalesceLocaleField('mediaCopy', localeId)},
      media${MEDIA_PROJECTION},
      link${LINK_PROJECTION},
      footerCta {
        ${coalesceLocaleField('footerCtaCopy', localeId)},
        ${coalesceLocaleField('footerCtaLabel', localeId)},
        footerCta${LINK_PROJECTION}
      }
    }
  }`
}
